/**
 * Venice's safe mode: Venice blurs a picture it classes as adult content unless a request says
 * otherwise (safe_mode on /image/generate and /image/multi-edit; its video has no such setting).
 * It stays on, as Venice has it, until the person turns it off in Settings, API keys. The choice
 * is kept on this device (in the desktop app, between runs). A picture already made blurred stays
 * as it is; the setting applies to the next ones.
 */
const KEY = 'venice_safe_mode';

/** Whether Venice is asked to blur adult content */
export const veniceSafeModeOn = (): boolean => {
    try { return localStorage.getItem(KEY) !== 'off'; } catch { return true; }
};

export const setVeniceSafeMode = (on: boolean): void => {
    try {
        if (on) localStorage.removeItem(KEY);
        else localStorage.setItem(KEY, 'off');
    } catch { /* storage unavailable: Venice's default stays */ }
};
